import { createIcon } from '@chakra-ui/react'

// Box Icons / Solid / Heart
export const OmHeartSolid = createIcon({
  displayName: 'Heart',
  viewBox: '0 0 24 24',
  d: 'M20.205,4.791c-1.137-1.131-2.631-1.754-4.209-1.754c-1.483,0-2.892,0.552-3.996,1.558 c-1.104-1.006-2.512-1.558-3.996-1.558c-1.578,0-3.072,0.623-4.213,1.758c-2.353,2.363-2.352,6.059,0.002,8.412L12,21.414 l8.207-8.207C22.561,10.854,22.562,7.158,20.205,4.791z',
})
